/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessagesTemplatesFileTemplate } from '../models/MessagesTemplatesFileTemplate';
import type { MessagesTemplatesNewTemplate } from '../models/MessagesTemplatesNewTemplate';
import type { MessagesTemplatesTTemplateActivity } from '../models/MessagesTemplatesTTemplateActivity';
import type { SystemCollectionsGenericKeyValuePairOfSystemStringMicrosoftExtensionsPrimitivesStringValues } from '../models/SystemCollectionsGenericKeyValuePairOfSystemStringMicrosoftExtensionsPrimitivesStringValues';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TemplatesApiService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List file templates for an application / entity type (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param applicationId
     * @param entityTypeId
     * @returns MessagesTemplatesFileTemplate OK
     * @throws ApiError
     */
    public getTemplatesApiListFileTemplates(
        applicationId: number,
        entityTypeId?: number,
    ): CancelablePromise<Array<MessagesTemplatesFileTemplate>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/templates',
            query: {
                'applicationId': applicationId,
                'entityTypeId': entityTypeId,
            },
        });
    }

    /**
     * Adds a new template. (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param requestBody The details of the new template to add.
     * @returns MessagesTemplatesFileTemplate OK
     * @throws ApiError
     */
    public putTemplatesApiAddTemplate(
        requestBody?: MessagesTemplatesNewTemplate,
    ): CancelablePromise<MessagesTemplatesFileTemplate> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rest/templates',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Updates a template. (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param requestBody The details of the updated template to add.
     * @returns MessagesTemplatesFileTemplate OK
     * @throws ApiError
     */
    public postTemplatesApiUpdateTemplate(
        requestBody?: MessagesTemplatesFileTemplate,
    ): CancelablePromise<MessagesTemplatesFileTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rest/templates',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Deletes a template. (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param requestBody The details of the template to delete, only if nothing is associated with it yet.
     * @returns MessagesTemplatesFileTemplate OK
     * @throws ApiError
     */
    public deleteTemplatesApiDeleteTemplate(
        requestBody?: MessagesTemplatesFileTemplate,
    ): CancelablePromise<MessagesTemplatesFileTemplate> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/rest/templates',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param applicationId
     * @param projectId
     * @returns MessagesTemplatesTTemplateActivity OK
     * @throws ApiError
     */
    public getTemplatesApiGetTemplateSummary(
        applicationId: number,
        projectId: number,
    ): CancelablePromise<Array<MessagesTemplatesTTemplateActivity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/templates_summary/{applicationId},{projectId}',
            path: {
                'applicationId': applicationId,
                'projectId': projectId,
            },
        });
    }

    /**
     * @param applicationId
     * @param projectId
     * @param entityId
     * @param templateId
     * @returns MessagesTemplatesTTemplateActivity OK
     * @throws ApiError
     */
    public getTemplatesApiGetSpecificTemplateSummary(
        applicationId: number,
        projectId: number,
        entityId: number,
        templateId: number,
    ): CancelablePromise<Array<MessagesTemplatesTTemplateActivity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}',
            path: {
                'applicationId': applicationId,
                'projectId': projectId,
                'entityId': entityId,
                'templateId': templateId,
            },
        });
    }

    /**
     * @param formData
     * @returns MessagesTemplatesTTemplateActivity OK
     * @throws ApiError
     */
    public postTemplatesApiPostTransitionUpdate(
        formData?: {
            formData?: Array<SystemCollectionsGenericKeyValuePairOfSystemStringMicrosoftExtensionsPrimitivesStringValues>;
        },
    ): CancelablePromise<Array<MessagesTemplatesTTemplateActivity>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rest/templates_activity_log_transition_template',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
